import { ConfigProvider, Radio, Typography } from "antd";

function Commonradiobutton({
  options,
  onChange,
  value,
  labelname,
  required = false,
  error,
  touched,
  name,
  className = "mb-1",
}: {
  options: any;
  onChange: (value: any) => void;
  value: any;
  labelname: string;
  required: boolean;
  error: any;
  touched: any;
  name: string;
  className?: string;
}) {
  return (
    <>
      <Typography className={className} style={{ fontWeight: 600 }}>
        {labelname}
        {required && (
          <span
            className="required_text"
            style={{ position: "absolute", marginTop: "0px" }}
          >
            *
          </span>
        )}
      </Typography>

      <ConfigProvider
        theme={{
          components: {
            Radio: {
              buttonCheckedBg: "#20a2a0",
            },
          },
        }}
      >
        <Radio.Group options={options} onChange={onChange} value={value} />
      </ConfigProvider>
    </>
  );
}

export default Commonradiobutton;
